import { useState } from "react";

const useModalHandlers = () => {
    const [showOrderModal, setShowOrderModal] = useState(false);
    const [showReinstateOrderModal, setShowReinstateOrderModal] =
        useState(false);
    const [showProductModal, setShowProductModal] = useState<
        Record<number, boolean>
    >({});

    const handleOrderModalClose = () => setShowOrderModal(false);

    const handleOrderModalShow = () => {
        setShowOrderModal(prev => {
            console.log(prev);
            return true;
        });
    };

    const handleReinstateOrderModalClose = () =>
        setShowReinstateOrderModal(false);

    const handleReinstateOrderModalShow = () =>
        setShowReinstateOrderModal(true);

    const handleProductModalClose = (productIndex: number) =>
        setShowProductModal(prev => ({ ...prev, [productIndex]: false }));

    const handleProductModalShow = (productIndex: number) =>
        setShowProductModal(prev => ({ ...prev, [productIndex]: true }));

    return {
        showOrderModal,
        showProductModal,
        handleOrderModalClose,
        handleOrderModalShow,
        handleProductModalClose,
        handleProductModalShow,
        showReinstateOrderModal,
        handleReinstateOrderModalClose,
        handleReinstateOrderModalShow,
    };
};

export default useModalHandlers;
